import ApiAcces from "@/shared/services/ApiAcces";
import type { UserProfile } from "../models/UserProfile";
import type IAccountManagerService from "../contracts/IAccountManagerService";
import type Page from "@/shared/models/Page";
import type PageRequest from "@/shared/models/PageRequest";
import type CreateUser from "../models/CreateUser";

export default class AccountManagerService
  extends ApiAcces
  implements IAccountManagerService
{
  async getPage(pageRequest: PageRequest): Promise<Page<UserProfile>> {
    return (await this.api.get("/api/profiles", { params: pageRequest })).data;
  }
  async get(userId: string): Promise<UserProfile> {
    return (await this.api.get(`/api/profiles/${userId}`)).data;
  }
  async create(newUser: CreateUser): Promise<UserProfile> {
    return (await this.api.post("/api/profiles", newUser)).data;
  }
  async update(id: string, newData: Partial<CreateUser>): Promise<void> {
    await this.api.patch(`/api/profiles/${id}`, newData);
  }
  async delete(id: string): Promise<void> {
    await this.api.delete(`/api/profiles/${id}`);
  }
  async resendConfirmation(id: string): Promise<void> {
    await this.api.post(`/api/profiles/${id}/resend-confirmation`);
  }
  async sendPasswordReset(id: string): Promise<void> {
    await this.api.post(`/api/profiles/${id}/send-password-reset`);
  }
  async getMe(): Promise<UserProfile> {
    return (await this.api.get("/api/profiles/me")).data;
  }
}
